import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService, ServicecallService } from 'src/app';
import { ApiConstants } from 'src/app/constants/api-constants';
import { ChartAttributes } from 'src/app/model/shared/components/entities/entities-profile/chart-builder';

@Component({
  selector: 'app-custom-chart-builder',
  templateUrl: './custom-chart-builder.component.html',
  styleUrl: './custom-chart-builder.component.css'
})
export class CustomChartBuilderComponent implements OnChanges {
  @Input() pageType: string;
  @Input() selfServiceChartAttributes: {
    chartAttributes: ChartAttributes, selectedDates: {
      from: Date,
      to: Date,
    }, details: { _id: string }
  };
  selectedDates: {
    from: Date,
    to: Date,
  }
  chartAttributes: ChartAttributes;
  entityId: string;
  private _getEntityAttributeSubscription: Subscription;
  private _subscription: Subscription;
  entityAtrributes: { entityId: string, value: number, timestamp: string }[] = [];
  entityHistogramAtrributes: { entityId: string, value: number, uniqueId: string, color: string, roundOf: number }[] = [];
  markLine: any;
  chartData: any;
  barCount: number = 5;
  barWidth: number = 10;
  isloader: boolean = true;
  isError: boolean = false;

  graphData: any;
  xAxisLabel: any;
  graphAxisDetails: any;
  //Dummy
  rawData = [{
    "name": "Trip 1", "start": [19.40633210334786, 87.78396087], "end": [17.27100502072211, 84.89664207728956], value:
    {
      good: {
        name: 'Good',
        entities: ['67e4bc7b7cdd945ce1422a5c', '67e4bc7b7cdd945ce1422a65'],
      },
      belowAverage: {
        name: 'Below Average',
        entities: ['67e4bc7b7cdd945ce1422a64', '67e4bc7b7cdd945ce1422a63'],
      },
      deteriorating: {
        name: 'Deteriorating',
        entities: ['67e4bc7b7cdd945ce1422a62'],
      }
    }
  }, {
    "name": "Trip 2", "start": [8.346058158915922, 71.33946161454968], "end": [6.231337992829216, 70.43922390475547], value: {
      good: {
        name: 'Good',
        entities: ['67e4bc7b7cdd945ce1422a57', '67e4bc7b7cdd945ce1422a65'],
      },
      belowAverage: {
        name: 'Below Average',
        entities: ['67e4bc7b7cdd945ce1422a64', '67e4bc7b7cdd945ce1422a63'],
      },
      deteriorating: {
        name: 'Deteriorating',
        entities: ['67e4bc7b7cdd945ce1422a62'],
      }
    }
  },
  {
    "name": "Trip 3", "start": [24.39180994535894, 90.73138255851696], "end": [20.87950549624676, 92.68463466376896], value:
    {
      good: {
        name: 'Good',
        entities: ['67e4bc7b7cdd945ce1422a5a', '67e4bc7b7cdd945ce1422a65'],
      },
      belowAverage: {
        name: 'Below Average',
        entities: ['67e4bc7b7cdd945ce1422a64', '67e4bc7b7cdd945ce1422a63'],
      },
      deteriorating: {
        name: 'Deteriorating',
        entities: ['67e4bc7b7cdd945ce1422a62'],
      }
    }
  }];
  stackedBarData: any;
  stackedBarColors: string[];
  stackedBarChartTitle: string;

  mockData: any = [
    {
      value: 30,
      timestamp: "2025-04-22T12:48:00+0000"
    },
    {
      value: 21,
      timestamp: "2025-04-22T12:52:00+0000"
    },
    {
      value: 26,
      timestamp: "2025-04-22T12:56:00+0000"
    },
    {
      value: 21,
      timestamp: "2025-04-22T12:56:30+0000"
    },
    {
      value: 26,
      timestamp: "2025-04-22T13:00:30+0000"
    },
    {
      value: 21,
      timestamp: "2025-04-22T13:01:00+0000"
    },
    {
      value: 26,
      timestamp: "2025-04-22T13:05:00+0000"
    },
    {
      value: 21,
      timestamp: "2025-04-22T13:05:30+0000"
    },
    {
      value: 26,
      timestamp: "2025-04-22T13:09:30+0000"
    },
    {
      value: 21,
      timestamp: "2025-04-22T13:10:00+0000"
    },
  ]

  constructor(public service: ServicecallService, private _datePipe: DatePipe, private _dataSer: DataService, private _router: Router) {
    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh' || res.name === 'trendUpdate') {
        if (this.chartAttributes && this.chartAttributes?.chartType && this.selectedDates) {
          this._getAttributeDetails();
        }
      }
    });
  }

  ngOnInit(): any {
    this.barCount = this.service.getConfiguration('tenantGenericConfig')?.analytics?.selfService?.histogramGraphBarCount ?? 5;
    this.barWidth = this.service.getConfiguration('tenantGenericConfig')?.analytics?.selfService?.histogramGraphBarWidth ?? 10;
  }

  ngOnChanges(): any {
    if (this.selfServiceChartAttributes) {
      this.chartAttributes = this.selfServiceChartAttributes?.chartAttributes;
      this.selectedDates = this.selfServiceChartAttributes?.selectedDates;
      this.entityId = this.selfServiceChartAttributes?.details?._id ?? null;
    }
    if (this.chartAttributes && this.selectedDates) {
      if (this.selfServiceChartAttributes?.chartAttributes?.chartType?.value === 'mock-line1' || this.selfServiceChartAttributes?.chartAttributes?.chartType?.value === 'mock-line2') {
        this.mockData = this.service.getConfiguration('customAnalyticsChartConfig')?.[this.selfServiceChartAttributes?.chartAttributes?.chartType?.value] ?? [];
        this.plotTemperatureMockGraph(this.mockData);
      } else {
        this._getAttributeDetails();
        if (this.chartAttributes?.chartType?.value === 'stacked-bar') {
          this.stackedBarData = this.service.getConfiguration('customAnalyticsChartConfig')?.stackedBarDetails?.rawData ?? this.rawData;
          this.stackedBarColors = this.service.getConfiguration('customAnalyticsChartConfig')?.stackedBarDetails?.color ?? ['#1F9254', '#F09001', '#d8271fc2'];
          this._setCustomStackedBarChartData();
        }
      }
    }
  }

  ngOnDestroy(): any {
    this._getEntityAttributeSubscription?.unsubscribe();
  }

  /**
   * Sets custom stacked bar chart data
   */
  private async _setCustomStackedBarChartData() {
    const {
      xAxisLabel,
      graphData,
      xAxisData,
    } = await this._generateStackedBarData(this.stackedBarData);

    this.xAxisLabel = xAxisLabel;
    this.graphData = graphData;
    this.stackedBarChartTitle = this.chartAttributes?.name;
    this.graphAxisDetails = {
      yAxisDetails: { name: 'Vehicles' },
      xAxisDetails: {
        name: 'Trips',
        data: xAxisData
      },
      color: this.stackedBarColors
    };
  }

  private _getRequestData() { //Check & make change only for self service
    return {
      source: 'heartbeat',
      entityIds: this.entityId,
      from: this._datePipe.transform(this.selectedDates?.from, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.selectedDates?.to, 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this.service.getSiteId(),
      attributes: this.chartAttributes && Object.keys(this.chartAttributes)?.length ? (this.chartAttributes?.yAxis2?.name ? [this.chartAttributes?.xAxis?.name, this.chartAttributes?.yAxis?.name, this.chartAttributes?.yAxis2?.name] : [this.chartAttributes?.xAxis?.name, this.chartAttributes?.yAxis?.name]) : [],
      includeHistory: false
    };
  }

  /**
   * Gets attribute details
   */
  private _getAttributeDetails() {
    this.isloader = true;
    this._getEntityAttributeSubscription = this.service.getEntityAttributeV1(this._getRequestData()).subscribe({
      next: (resp: any) => {
        this.entityAtrributes = resp?.[this.chartAttributes?.yAxis?.name];
        if (this.selfServiceChartAttributes?.chartAttributes?.chartType?.value === 'bar') {
          this.plotBarChart();
        } else {
          this.plotHistogramChart();
        }
        this.isloader = false;
      },
      error: () => {
        this.isloader = false;
        this.isError = true;
        this.entityAtrributes = [];
      }
    })
  }

  /**
   * Generates stacked bar data
   * @param rawData 
   * @returns  
   */
  private async _generateStackedBarData(rawData: any[]) {
    const categoryMap = new Map<string, { counts: number[]; entities: string[][]; start: string[], end: string[] }>();
    const xAxisData: string[] = [];
    const locationPromises: Promise<string | void>[] = [];
    const coordinateCache = new Map<string, Promise<string>>();

    //Function to fetch location (For each trip - start & end)
    const getCachedLocation = (lat: number, lng: number) => {
      const key = `${lat},${lng}`;
      if (!coordinateCache.has(key)) {
        coordinateCache.set(key, this.getLocationFromCoordinates(lat, lng)
          .then(loc => loc ?? '--')
          .catch(() => '--')
        );
      }
      return coordinateCache.get(key)!;
    };

    for (let tripIndex = 0; tripIndex < (rawData?.length || 0); tripIndex++) {
      const tripData = rawData[tripIndex];
      const tripName = tripData?.name;
      xAxisData.push(tripName);

      for (const key of Object.keys(tripData?.value || {})) {
        const category = tripData.value[key];
        if (!categoryMap.has(category?.name)) {
          categoryMap.set(category.name, {
            counts: Array(rawData.length).fill(0),
            entities: Array(rawData.length).fill([]),
            start: Array(rawData.length).fill('--'),
            end: Array(rawData.length).fill('--')
          });
        }

        const categoryData = categoryMap.get(category.name);
        categoryData.counts[tripIndex] = category?.entities?.length || 0;
        categoryData.entities[tripIndex] = category?.entities || [];

        if (tripData?.start?.[0] != null && tripData?.start?.[1] != null) {
          locationPromises.push(
            getCachedLocation(tripData.start[0], tripData.start[1])
              .then(loc => categoryData.start[tripIndex] = loc)
          );
        }

        if (tripData?.end?.[0] != null && tripData?.end?.[1] != null) {
          locationPromises.push(
            getCachedLocation(tripData.end[0], tripData.end[1])
              .then(loc => categoryData.end[tripIndex] = loc)
          );
        }
      }
    }

    await Promise.all(locationPromises);

    const xAxisLabel = Array.from(categoryMap.keys());
    const graphData = Array.from(categoryMap.entries()).map(([key, val]) => ({
      value: val
    }));
    const tooltipEntities = Array.from(categoryMap.values()).map(vehicle => vehicle?.entities);

    return {
      xAxisLabel,
      graphData,
      xAxisData,
      tooltipEntities,
    };
  }

  /**
   * Gets location from coordinates
   * @param latitude 
   * @param longitude 
   * @returns  
   */
  async getLocationFromCoordinates(latitude: number, longitude: number) {
    try {
      const response = await fetch(
        `${ApiConstants?.HERE_REVERSE_GEOCODE_URL}?at=${latitude},${longitude}&apiKey=${ApiConstants?.HERE_API_KEY}&lang=en-US`
      );
      const data = await response.json();
      if (data?.items?.[0]?.address?.label) {
        const location = data.items[0].address.label;
        return location;
      }
    } catch (error) {
      console.error(`Failed to fetch location `);
    }
  };

  /**
   * Plots bar chart
   */
  plotBarChart() {
    // Group by day of week and count unique entityIds
    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayMap = {};
    const uniqueEntityIdsByDay = {};

    dayNames.forEach(day => {
      dayMap[day] = new Set();
      uniqueEntityIdsByDay[day] = new Set();
    });

    this.entityAtrributes?.forEach(item => {
      const date = new Date(item.timestamp);
      const dayOfWeek = date.getDay();
      const dayName = dayNames[dayOfWeek];

      dayMap[dayName].add(item.entityId);
      uniqueEntityIdsByDay[dayName].add(item.entityId);
    });

    const days = [];
    const counts = [];
    const entityData = {};

    dayNames.forEach(day => {
      days.push(day);
      counts.push(dayMap[day] ? dayMap[day].size : 0);
      // Store unique entityIds as array for each day
      entityData[day] = Array.from(uniqueEntityIdsByDay[day]);
    });

    this.chartData = {
      title: {
        text: this.chartAttributes?.yAxis?.uom ? `${this.chartAttributes?.name} (${this.chartAttributes?.yAxis?.uom})` : this.chartAttributes?.name,
        top: 0,
        textStyle: {
          fontSize: 12,
          fontWeight: 'bold'
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: function (params) {
          return `${params[0].name}: ${params[0].value}`;
        }
      },
      xAxis: {
        type: 'category',
        data: days,
        axisLabel: {
          interval: 0, // Force showing all labels
          rotate: 0,
          fontSize: 8
        },
        axisTick: {
          alignWithLabel: true
        },
        name: '',
        nameLocation: 'middle',
        nameGap: 30
      },
      yAxis: {
        type: 'value',
        name: 'Vehicle Count',
        nameLocation: 'middle',
        nameGap: 40
      },
      series: [{
        name: 'Vehicle Count',
        type: 'bar',
        data: counts.map((count, index) => {
          return {
            value: count,
            dayName: days[index],
            entityIds: entityData[days[index]] // Store entityIds in each data point
          };
        }),
        barWidth: '60%',
        itemStyle: {
          color: '#5470c6'
        },
        label: {
          show: true,
          position: 'top',
          fontSize: 12
        },
        markLine: {
          data: [
            ...(this.chartAttributes?.yAxis?.markers?.max
              ? [{ yAxis: this.chartAttributes?.yAxis?.markers?.max }]
              : []),
            ...(this.chartAttributes?.yAxis?.markers?.min
              ? [{ yAxis: this.chartAttributes?.yAxis?.markers?.min }]
              : []),
            ...(this.chartAttributes?.xAxis?.markers?.max
              ? [{ xAxis: this.chartAttributes?.xAxis?.markers?.max }]
              : []),
            ...(this.chartAttributes?.xAxis?.markers?.min
              ? [{ xAxis: this.chartAttributes?.xAxis?.markers?.min }]
              : [])
          ],
          lineStyle: {
            type: 'solid',
            color: 'rgba(250, 174, 165, 1)',
            width: 1
          },
          symbol: 'none',
          label: {
            show: false
          },
          tooltip: {
            show: false // Disable tooltip for markPoint
          },
        }
      }],
      grid: {
        left: '10%',
        bottom: '15%',
        top: '10%',
        containLabel: true
      }
    };
  }

  onChartClick(clickedChart) {
    this.service.setEntitiesFilter(clickedChart?.data?.entityIds);
    this._router.navigateByUrl('/vehicles/active');
  }

  plotHistogramChart() {
    this.entityHistogramAtrributes = this.entityAtrributes?.map((item: any) => {
      return { entityId: item?.entityId, value: item?.value !== null ? item?.value.toFixed(0) : null, uniqueId: item?.uniqueId, color: '#6ECFF2', roundOf: 0, title: this.chartAttributes?.name, uom: this.chartAttributes?.yAxis?.uom }
    })?.filter((elem: any) => elem.value !== null);
    this.markLine = {
      yAxis: {
        markers: {
          min: this.chartAttributes?.yAxis?.markers?.min,
          max: this.chartAttributes?.yAxis?.markers?.max
        }
      },
      xAxis: {
        markers: {
          min: this.chartAttributes?.xAxis?.markers?.min,
          max: this.chartAttributes?.xAxis?.markers?.max
        }
      }
    }

  }

  plotTemperatureMockGraph(mockData: any) {
    this.isloader = false;
    this.chartData = {
      xAxis: {
        type: 'time',
        splitLine: {
          show: false
        },
        axisLabel: {
          formatter: function (value) {
            const date = new Date(value);
            const time = date.toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              // second: '2-digit',
              hour12: false
            });
            const formattedDate = date.toLocaleDateString('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric'
            });
            return `${time}`
          },
        },
        name: 'Time',
        nameLocation: 'middle',
        nameGap: 35,
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          data: mockData?.map(item => { return [item.timestamp, item.value] }),
          type: 'line'
        }
      ],
      title: {
        text: this.chartAttributes?.yAxis?.uom ? `${this.chartAttributes?.name} (${this.chartAttributes?.yAxis?.uom})` : this.chartAttributes?.name,
        top: 0,
        textStyle: {
          fontSize: 12,
          fontWeight: 'bold'
        }
      },
      grid: {
        containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'cross' },
        formatter: function (params) {
          const point = params[0]; // First point on the axis
          const date = new Date(point.axisValue);
          const formattedTime = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          });
          const formattedDate = date.toLocaleDateString('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric'
          });

          let tooltipHtml = `<b>${formattedDate} ${formattedTime}</b><br/>`;

          params.forEach(item => {
            tooltipHtml += `${item.marker} <b>${item.value[1]}</b><br/>`;
          });

          return tooltipHtml;
        }
      }
    };
  }

}
